import React from "react";
import Page from "../templates/conserve/water/waterpage";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Water Conservation | Apparel Industry Sustainability | Hirdaramani
        </title>
        <meta
          name="title"
          content="Water Conservation | Apparel Industry Sustainability 
| Hirdaramani"
        />
        <meta
          name="description"
          content="Explore our efforts to address this challenge and meet our Future First target of reducing freshwater consumption per garment by 50%."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/conserve/water/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Water Conservation" />
        <meta
          property="og:title"
          content="Water Conservation | Apparel Industry Sustainability 
| Hirdaramani"
        />
        <meta
          property="og:description"
          content="Explore our efforts to address this challenge and meet our Future First target of reducing freshwater consumption per garment by 50%."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/conserve/water/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
